import { connect } from 'react-redux'
import InfoModal from './infoModal';

export default connect()(InfoModal);
